/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EMarkerShapeType {
  Circle = 2,
  Rectangle = 3,
  Polygon = 4
}
